// The rune count, the rune cut and the space tidy of a text. A rune is one
// code point, the unit of every text limit of the server. It is a leaf
// with no import.

/** The length of a text in runes (code points), the unit of the limits.
 *  It walks the string and builds no array. */
export function runeCount(s: string): number {
  let n = 0;
  for (const _ of s) n++;
  return n;
}

/** Cuts a text to at most `max` code points. */
export function cutRunes(s: string, max: number): string {
  const points = Array.from(s);
  return points.length <= max ? s : points.slice(0, max).join('');
}

/** A name as a person means it: no space at the ends, and one space for
 *  each run of white space inside. */
export function tidySpaces(s: string): string {
  return s.trim().replace(/\s+/g, ' ');
}
